import { render, staticRenderFns } from "./dShare.vue?vue&type=template&id=a5f25eae&scoped=true&"
import script from "./dShare.vue?vue&type=script&lang=js&"
export * from "./dShare.vue?vue&type=script&lang=js&"
import style0 from "./dShare.vue?vue&type=style&index=0&id=a5f25eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f25eae",
  null
  
)

export default component.exports